export abstract class TrackingService {
  public abstract addEvent(data: any, collection?: string): void;
}
